import { Language as LanguageIcon } from "@mui/icons-material";
import { IconButton, Tooltip } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";

import { topbarStore } from "shared/common/stores/topbarStore";
import LanguageSelector from "./LanguageSelector";

export default function Language() {
  const { t } = useTranslation();

  const changeAnchorDate = topbarStore((state) => state.changeAnchorDate);
  const changeShowHelp = topbarStore((state) => state.changeShowHelp);
  const changeAnchorLang = topbarStore((state) => state.changeAnchorLang);

  //open and close language popover
  const handleLanguageMenuOpen = (event: React.MouseEvent<HTMLElement>) => {
    changeAnchorLang(event.currentTarget);
    changeShowHelp(false);
    changeAnchorDate(null);
  };

  return (
    <>
      <Tooltip
        title={t("tooltip.language")}
        placement="bottom"
        enterDelay={400}
        classes={{ tooltip: "infra3d-buttonDescription" }}
      >
        <IconButton
          size="medium"
          aria-label="Language"
          classes={{ root: "infra3d-iconBackground" }}
          aria-controls={"Language"}
          onClick={handleLanguageMenuOpen}
          aria-haspopup="true"
          sx={{
            color: "white",
            "@media (hover: hover)": {
              ":hover": { color: "secondary.main" },
            },
          }}
        >
          <LanguageIcon fontSize="medium" />
        </IconButton>
      </Tooltip>
      <LanguageSelector />
    </>
  );
}
